<template>
  <div class="main-panel">
    <div class="sideBar">
      <water-fill-chart/>
      <div class="menu">
        <ul>
          <li @click="$router.push(item.link)" :class="{'active' :$route.matched[1].name === item.tag }"
              class="not-active" v-for="(item , index) in menuItems"
              :key="index">
            <inline-svg :class="{'addFriend' : item.image === 'adding.svg'}"
                        :src="require('../../assets/icon/panel/' + item.image)"/>
            <span class="name-item">{{ item.name }}</span>
          </li>
          <inline-svg class="line" :src="require('../../assets/public/line.svg')"/>
          <li class="exite-li" @click="logOut">
            <inline-svg :src="require('../../assets/icon/exite.svg')"/>
            <span class="exite-item">خروج از حساب</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
<transition name="panel" enter-active-class="animate__animated animate__lightSpeedInLeft" >
  <router-view/>
</transition>
    </div>
  </div>
</template>

<script>
import WaterFillChart from "../tools/water-fill-chart";
import io from "socket.io-client";

export default {
  name: "the-panel",
  components: {WaterFillChart},
  data() {
    return {
      menuItems: [
        {name: 'داشبورد', image: 'dashboard.svg', link: 'dashboard', tag: 'Dashboard'},
        {name: 'کیف پول', image: 'assets.svg', link: 'wallet', tag: 'Wallet'},
        {name: 'کیف پول صرافی', image: 'assets.svg', link: 'walletEx', tag: 'WalletEx'},

        {name: 'پورتفولیو', image: 'portfolio.svg', link: 'Portfolio', tag: 'Portfolio'},
        {name: 'پورتفولیو صرافی', image: 'portfolio.svg', link: 'PortfolioEx', tag: 'PortfolioEx'},

        {name: 'تاریخچه', image: 'history.svg', link: 'history', tag: 'History'},
        {name: 'دعوت از دوستان', image: 'adding.svg', link: 'referralCode', tag: 'ReferralCode'},
        {name: 'پروفایل', image: 'profile.svg', link: '/thekyc', tag: 'kyc'},
        {name: 'تنظیمات', image: 'setting.svg', link: 'setting', tag: 'Setting'},
      ],
      active: false
    }
  },
  methods: {
    logOut() {
      this.$logout();
    }
  },
  created() {
    const io = require("socket.io-client");
    const socket = io("https://socket.vistadev.xyz/socket", {
      path: "/vtp",
      transports: ["websocket"],
      extraHeaders: {
        Authorization: [this.state.token],
      },
      upgrade: true,
      connected: true,
      reconnection: true,
      rejectUnauthorized: false,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      timeout: 20000,

    });
    socket.connect();

    socket.on("connect", () => {
      console.log(socket)
      console.log("connected");
    });
    socket.on(`NOTIFICATIONS:${this.state.userInfo.email}`, (data) => {

      console.log('notifs', data)

      this.$store.commit("setNotifs", data);
      console.log("notifications", this.$store.state.notifications);
    })


    // const listener = .toString();
    // console.log(this.state.userInfo.email)


  }
}
</script>

<style lang="scss" scoped>

.main-panel {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  background-image: url("../../assets/backgrounds/pannel.png");
  background-position: center;
  background-size: cover;
  flex-wrap: nowrap;
  direction: rtl;
  padding: 20px;
  gap: clamp(10px, 0.7vw, 20px);

  .sideBar {
    display: flex;
    flex-direction: column;
    gap: 45px;
    flex-grow: 1;
    flex-basis: 100px;
    height: auto;
    justify-content: center;


    .menu {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .addFriend {
        width: 19px !important;
        height: 19px !important;
      }

      .exite-li {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-top: -20px;
      }

      .exite-item {
        font-size: clamp(8px, 2vw, 16px);
        color: #FFFFFF;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 50px;

        .name-item {
          font-size: clamp(8px, 2vw, 16px);
          white-space: nowrap;
        }

        .not-active {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          color: rgba(215, 200, 200, 1);
          cursor: pointer;
          font-size: clamp(12px, 2vw, 16px);

          svg {
            fill: rgba(215, 200, 200, 1);
            background-color: #595959;
            padding: clamp(5px, 0.7vw, 10px);
            border-radius: 8px;
          }
        }


        .active {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          color: rgba(251, 251, 253, 1) !important;
          cursor: pointer;
          font-size: clamp(12px, 2vw, 16px);

          svg {
            fill: rgba(251, 251, 253, 1) !important;
            background-color: #1199FA;
            padding: clamp(5px, 0.7vw, 10px);
            border-radius: 8px;
          }
        }
      }
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    flex-grow: 7;
    flex-basis: 700px;
  }
}

@media (max-width: 600px) {
  .name-item {
    display: none;
  }

  .exite-li svg {
    margin-right: 3px;
  }
  .exite-item {
    display: none;
  }

  .line {
    display: none;
  }
}
</style>